
<template>
    <div >
      <div class="main-title row pt-2">
        <div class="col-md-12 col-lg-2">
          <span style="font-weight: 600; font-size: 20px;">{{pageTitle}}</span>
        </div>
        <div class="col-md-12 col-lg-10 flex-bw pl-0 pr-0 onIpad">
          <div class="col-md-8 col-lg-5 pl-0">
            <div class="search-box">
              <i class="fas fa-search mr-2"></i>
              <input type="text" class="search-input"
                     @keydown.enter="doFilter('keyword', filter.keyword)"
                     v-model="filter.keyword" placeholder="Tìm kiếm"/>
            </div>
          </div>
          <div class="col-md-4 col-lg-5 flex-end" style="height: 40px">
            <button type="button" @click="clearFilter()" class="btn btn-default">Xóa lọc</button>
            <router-link :to="'/tags/form?tagTypeId=' + tagType.id" class="btn  btn-save ml-1"><i class="fa fa-plus"/> Thêm </router-link>
          </div>
        </div>

      </div>
      <div class="row" v-if="this.numberRecord > 15">
        <div class="col-md-2"></div>
        <div class="col-md-12 col-lg-10 PaginateTop">
          <Paginate :value="paginate" @change="pageChange" class="mb-0 mt-2"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-2">
          <div class="number_of_records">
            <label for="" style="width: 90px; margin-bottom: 0;">{{$t('message.common.numberRecord')}}:</label>
            <select style=" border: none;outline: none;" @change="changeRecords" id="number_of_records">
              <option value="15">15</option>
              <option value="20" selected="selected">20</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <!-- <option value="100">100</option> -->
            </select>
          </div>
        </div>
        <div class="col-md-12 col-lg-10">
          <div class="row mt-3 pr-1">
            <table class="table table-index table-striped">
              <thead>
              <tr>
                <th scope="col" class="checkbox-table"><input v-model="checkedAll" @change="onCheckedAll(checkedAll)" type="checkbox"/></th>
                <th scope="col" v-for="field in fields" :key="field.field" >
                  <TableSortField :current="sortData.field" @onsort="sort" :name="field.name" :field="field.field"/>
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="entry in entries" :key="entry.id">
                <td><input v-model="entry.checked" type="checkbox"/></td>
                <td scope="col" v-for="field in fields" :key="field.field" v-text="r(entry, field.field, field.render)"></td>
                <th>
                  <router-link v-if="tagType.id===2" class="btn " :to="'/tags/form?id=' + entry.id +'&tagTypeId=' + entry.tagTypeId">
                    <i class="fa fa-edit"/>
                  </router-link>
                  <button v-else class="btn btn-primary" type="button" @click="showModalProductTag(entry)">
                    <i class="fa fa-edit"/>
                  </button>
                </th>
              </tr>
              </tbody>
            </table>

            <Paginate :value="paginate" @change="pageChange"/>
          </div>
        </div>
      </div>
        <ModalProductTagForm ref="ModalProductTagForm"/>
    </div>
</template>

<script>
    import {$alert, $get, clone, setArray, getSearchQuery} from "@/lib/utils";
    import Paginate from "@/components/Paginate";
    import TableSortField from "@/components/TableSortField";
    import ModalProductTagForm from "./ModalProductTagForm";
    import store from "../../store";

    export default {
        name: "TagIndex",
        components: {TableSortField, Paginate, ModalProductTagForm},
        mounted() {
            //document.title = 'Quản lý nhóm khách hàng';
            this.load()
        },
        data() {
            const query = getSearchQuery();

            return {
                filter: {
                    keyword: query.keyword,
                },
                checkedAll: false,
                pageTitle: '',
                fields: [],
                entries: [],
                sortData: {
                    field: 'id',
                    direction: 'desc',
                },
                tagType: {},
                paginate: {
                    currentPage: parseInt(query.page) || 1,
                    lastPage: 1
                },
              numberRecord:20,
            }
        },
        methods: {
            showModalProductTag(entry) {
                this.$refs.ModalProductTagForm.show(entry);
            },
            async clearFilter() {
                await this.$router.replace({
                    path: '/tags/index',
                    query: {
                        tagTypeId: this.tagType.id
                    }
                });

                Object.keys(this.filter).forEach(key => {
                    this.filter[key] = '';
                });

                this.load();
            },
            getCheckedIDs() {
                return this.entries.filter(e => e.checked).map(e => e.id);
            },
            onCheckedAll(value) {
                setArray(this.entries, {
                    checked: value
                });
            },
            async doFilter(field, value) {
                const query = clone(this.$route.query);
                query[field] = value;
                await this.$router.push({query: query});
                this.load();
            },
            async sort(field, direction) {
                this.sortData = {
                    field, direction
                };

                const query = clone(this.$route.query);
                query.sort_field = field;
                query.sort_direction = direction;

                await this.$router.push({query: query});
                this.load();


            },
            async pageChange(page) {
                await this.$router.push({query: { page:page, tagTypeId: this.tagType.id,numberRecord:this.numberRecord,keyword:this.filter.keyword }});
                this.load();
            },
            async load() {
                const res = await $get('/v1/tags/data', {...this.$route.query,'numberRecord':this.numberRecord});
                if (res.code === 404) {
                    store.commit('SetIsPageNotFound', true);
                    return;
                }

                if (res.code !== 200) {
                    $alert(res);
                    return;
                }

                setArray(res.data.entries, {
                    checked: false
                });

                this.fields = res.data.fields;
                this.paginate = res.data.paginate;
                this.entries = res.data.entries;
                this.pageTitle = res.data.tagType.name;
                this.tagType = res.data.tagType;
                document.title = this.pageTitle;

            },
          changeRecords(){
            this.numberRecord = document.getElementById('number_of_records').value;
            this.load();
          },
        }
    }
</script>
